import { useParams } from "react-router";
import {
  TreatmentComponent,
  TreatmentComponentSkeleton,
} from "@/services/backend/rlt/treatments/components/treatment-component";
import { Column } from "@/services/backend/rlt/treatments/lib/treatment-component-state";
import { useRltOrderShowQuery } from "@/services/backend/rlt/orders/api/order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import t from "@/lang/lang";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { TreatmentRemark } from "@/services/backend/rlt/treatments/components/treatment-remark";

export function OrderTreatmentRoute() {
  const { orderId } = useParams();

  const {
    data: order,
    isLoading,
    error,
  } = useRltOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <TreatmentComponentSkeleton />;
  }

  return (
    <div className="grid gap-2">
      <TreatmentComponent
        treatmentId={order!.treatmentId}
        availableColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.Cycle,
          Column.Formula,
          Column.CleanTime,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.SpecialDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
        defaultColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.Cycle,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
      />
      <TreatmentRemark treatmentId={order!.treatmentId} />
      <Textblocks
        subdomain={GSMSubdomain.RLT}
        documentKind={GSMDocumentKind.Treatment}
        documentId={order!.treatmentId}
        title={t("Allgemeine Bemerkungen im Leistungsverzeichnis")}
        defaultOpen={false}
      />
    </div>
  );
}
